import React from 'react';
import { markAsProductBundleReady } from '@atlassian/jira-spa/src/services/mark-as-product-bundle-ready/index.tsx';
import { LazyPage } from '@atlassian/jira-spa/src/view/lazy-page/index.tsx';
import { lazyForPaint } from '@atlassian/react-loosely-lazy';

export const LazyPrioritiesPage = lazyForPaint(() =>
	markAsProductBundleReady(
		import(
			/* webpackChunkName: "async-admin-pages-priorities", jiraSpaEntry: "async-admin-pages-priorities" */ '@atlassian/jira-admin-pages-priorities'
		),
	),
);

const PrioritiesPage = () => (
	<LazyPage Page={LazyPrioritiesPage} pageId="jira-admin-pages-priorities" shouldShowSpinner />
);

export default PrioritiesPage;
